import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AppCoreComponent, EnvironmentService, TokenDataService } from '@totvsmoda/core';
import { Environment } from 'src/environments/environment';


declare let gtag: Function;
@Component({
  standalone: true,
  imports: [AppCoreComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  constructor(private router: Router, private tokenService: TokenDataService) {
    inject(EnvironmentService).environment = Environment;
  } 

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const token = localStorage.getItem("jwtToken")
        if (token)
        {
          let tenant = this.tokenService.tenant.toUpperCase()

          gtag('set', { user_id: tenant });
        }
      }
    });
  }

  title: string = 'TOTVS Moda - Industrial';
  imageMenuCode: number = 700;
  theme: string = 'assets/images/theme.png';
} 